import { render, staticRenderFns } from "./SupplierQuoted.vue?vue&type=template&id=23770f2a&scoped=true&"
import script from "./SupplierQuoted.vue?vue&type=script&lang=js&"
export * from "./SupplierQuoted.vue?vue&type=script&lang=js&"
import style0 from "./SupplierQuoted.vue?vue&type=style&index=0&id=23770f2a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23770f2a",
  null
  
)

export default component.exports